<template>
  <div class="boss-pulldown-container boss-published">
    <label
      class="boss-pulldown-menu"
      for="boss-published-item"
    >
      <select
        id="boss-published-item"
        v-model="selected"
        :disabled="!isSelectable"
        class="boss-pulldown-menu-item"
        data-test="job-pulldown"
      >
        <option
          v-for="(job,key) in jobs"
          :key="key"
          :value="job.id.toString()"
        >求人ID: {{ job.id }} {{ job.name }}</option>
      </select>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ScoutJobHeader',
  props: {
    jobs: {
      type: Array,
      required: true,
      validator (val) {
        return (val.every(v => Object.prototype.hasOwnProperty.call(v, 'id') && Object.prototype.hasOwnProperty.call(v, 'name')))
      }
    },
    isSelectable: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data () {
    return {
      managementName: ''
    }
  },
  computed: {
    selected: {
      get () {
        return this.$route.params.jobId
      },
      set (val) {
        this.onChangeJob(val)
      }
    }
  },
  methods: {
    onChangeJob (val) {
      const path = this.$route.path.replace(/jobs\/[0-9]+/, `jobs/${val}`)
      this.$router.push(path)
    }
  }
}
</script>
